import { TimeRangeEnum } from '@libs/backend-common';

export const PERIOD_TRANSLATIONS = {
  [TimeRangeEnum.ONE_DAY]: 'time_one_day',
  [TimeRangeEnum.ONE_WEEK]: 'time_one_week',
  [TimeRangeEnum.ONE_MONTH]: 'time_one_month',
  [TimeRangeEnum.SIX_MONTHS]: 'time_six_months',
  [TimeRangeEnum.ONE_YEAR]: 'time_one_year_full',
};
